import { combineReducers } from 'redux'
import { getType } from 'typesafe-actions'

import {
  createOrganization,
  deleteOrganizationContent,
  fetchAllOrganizations,
  fetchOneOrganization,
  OrganizationAction,
  setOneOrganization,
} from './actions'
import { OrganizationsState } from './types'

export const organizationsReducer = combineReducers<OrganizationsState, OrganizationAction>({
  isFetching: (isFetching = false, action) => {
    switch (action.type) {
      case getType(fetchAllOrganizations.request):
        return true
      case getType(fetchAllOrganizations.success):
      case getType(fetchAllOrganizations.failure):
        return false
      default:
        return isFetching
    }
  },
  items: (organizations = {}, action) => {
    switch (action.type) {
      case getType(fetchAllOrganizations.request):
        return {}
      case getType(fetchAllOrganizations.success):
        return action.payload
      case getType(fetchOneOrganization.success):
      case getType(createOrganization.success):
      case getType(setOneOrganization):
      case getType(deleteOrganizationContent.success): {
        const organization = action.payload
        return {
          ...organizations,
          [organization.id]: organization,
        }
      }
      default:
        return organizations
    }
  },
})
